import { render } from "./FinishTranferAgent.vue?vue&type=template&id=36d92e40"
import script from "./FinishTranferAgent.vue?vue&type=script&lang=js"
export * from "./FinishTranferAgent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__